import { getUid } from 'Services/WeaverUtils'

export initialState = {
  nodeData:     {} # map of all the currently loaded Weaver.ModelClass nodes
  treeData:     {} # map keyed with nodeIds, and containing arrays of all their children's ids
  rootNodes:    [] # list of ids of root nodes
  expandedKeys: []
  isLoading:    true
}

export reducer = (state, { type, payload }) ->
  try
    switch (type)
      when 'SET_NODES'
        current = state.nodeData
        updated = _.keyBy(payload.data, getUid)
        for k, v of updated
          if not current[k]?
            current[k] = v
          else if v._loaded # Update old nodes only if the new ones are loaded
            current[k] = v 
        {
          state...,
          nodeData: current
        }
      when 'SET_ROOT_NODES'
        { state..., rootNodes: payload.data }
      when 'SET_TREE_NODES'
        {
          state...,
          treeData: _.mergeWith({}, state.treeData, payload.data, (obj, src) ->
            if _.isArray(obj)
              _.uniq(obj.concat(src))
          ) }
      when 'CLEAR_TREE'
        {
          state...,
          nodeData: {},
          treeData: {},
          rootNodes: [],
          expandedKeys: []
        }
      when 'TOGGLE_EXPANDED'
        if payload.data.isExpanded
          { state..., expandedKeys: [state.expandedKeys..., payload.data.key] }
        else
          { state..., expandedKeys: state.expandedKeys.filter((k) -> k isnt payload.data.key) }
      when 'SET_LOADING'
        { state..., isLoading: payload.data }
      else
        throw new Error("TreeData reducer recieved an invalid action type (#{ type }).")
  catch e
    console.error(e)
